export const LABEL_FONT_STYLE: React.CSSProperties = {
    fontWeight: 400,
    fontSize: '14px',
    color: '#2A2C2E',
}

export const LABEL_BOLD_FONT_STYLE: React.CSSProperties = {
    fontWeight: 700,
    fontSize: '14px',
    color: '#2A2C2E',
}
